export const FooterEn = {
    'support' : 'support',
    'question' : 'Questions and answers',
    'support sytem' : 'Support sytem',
    'contact us' : 'Contact us',
    'partners' : 'partners',
    'our supplyers' : 'Our suppliers',
    'add as supplier' : 'Add yourself as a supplier',
    'talk to us' : 'talk to us'
}